// filepath: apps/web/src/features/directory/positions/PositionsRoute.tsx
//
// FR-UI-DIR-1 AC-4 — route shell for /positions.

import { PositionsPage } from "./PositionsPage";

export function PositionsRoute(): React.ReactElement {
  return <PositionsPage />;
}
